(ns app.domain.property.id-util
  (:require [clojure.string :as str])
  #?(:clj (:import [org.apache.commons.lang3 StringUtils])))

#?(:clj (set! *warn-on-reflection* true))

(defmulti normalize-property-id (fn [subdivision-or-country _] subdivision-or-country))

(defmethod normalize-property-id :default [_ property-id] property-id)

(defmethod normalize-property-id :CA-ON [_ property-id]
  #?(:clj  (StringUtils/rightPad ^String property-id 19 "0")
     :cljs (let [padding (- 19 (count property-id))]
             (if (pos? padding)
               (apply str property-id (repeat padding "0"))
               property-id))))

(defmulti denormalized-property-ids
  "The GIS values a stored property id may have been normalized from."
  (fn [subdivision-or-country _] subdivision-or-country))

(defmethod denormalized-property-ids :default [_ property-id] [property-id])

(defmethod denormalized-property-ids :CA-ON [_ property-id]
  (if (and (= 19 (count property-id)) (str/ends-with? property-id "0000"))
    [property-id (subs property-id 0 15)]
    [property-id]))
